import {h, Fragment} from "preact"
import { useCustomConfig } from "../../../hooks/useCustomConfig"
import { useBackInStock } from "../../../hooks/useBackInStock"
import { IconBag } from '../../icons'

export default function FloatingButtons ({ product, productHandle }) {

    const { customConfig } = useCustomConfig();
    const { openQuickView } = customConfig;
    // const { backInStock } = useBackInStock({ productHandle })
    const backInStock = null; // This should be implemented after launch

    const handleQuickView = ({ event, url }) => {
        event.preventDefault();
        if (openQuickView) openQuickView(url)
    } 

    return (
        <div className="floating-buttons flex flex-wrap direction-column">
            {backInStock ? 
                <div dangerouslySetInnerHTML={{ __html: backInStock }}></div>
                :
                <button type="button" tabindex="0" className="cta" data-url={product.url} aria-label="More details" onClick={(event) => handleQuickView({ event, url: product.url })}>
                    <span className="circle flex align-items-center justify-content-center ease-animation highlight-hover">
                        <IconBag />
                    </span>
                </button>
            }
            
        </div>
    )
}